import {
  WatchLaterOutlined,
  LocationOnOutlined,
  PersonOutline,
} from '@material-ui/icons';
import { googleCalendarEventUrl } from 'google-calendar-url';
import GoogleMapReact from 'google-map-react';

import { format } from 'date-fns';
import { es } from 'date-fns/locale';

import { mapStyles } from '../../data/mapStyles';
import { getLogo } from '../../utils/event';

const Marker = ({ text }) => <div className="c-map-input__marker">{text}</div>;

const getUTCFormat = (date) =>
  date
    .toISOString()
    .split('.')[0]
    .replaceAll('-', '')
    .replaceAll(':', '')
    .replaceAll('.', '');

const EventDetails = ({
  user,
  location,
  initDate,
  finishDate,
  title,
  description,
}) => {
  const url = googleCalendarEventUrl({
    start: getUTCFormat(new Date(initDate)),
    end: getUTCFormat(new Date(finishDate)),
    title,
    details: description,
    location: location?.formatted_address,
  });
  const haveGoogleMapsLocation =
    location?.lat && location?.lng && location?.formatted_address;

  return (
    <div className="c-event-details">
      <h2>Detalles</h2>
      <div className="c-event-details__box">
        <div className="c-event-details__info">
          <div className="c-event-details__time">
            <h3 className="c-event-details__title">
              <WatchLaterOutlined />
              Horarios
            </h3>
            <span className="c-event-details__span-highlight">Empieza:</span>
            <span className="c-event-details__span">{`${format(
              new Date(initDate),
              'dd LLLL - hh:mm',
              {
                locale: es,
              }
            )}h`}</span>
            <span className="c-event-details__span-highlight">Termina:</span>
            <span className="c-event-details__span">{`${format(
              new Date(finishDate),
              'dd LLLL - hh:mm',
              {
                locale: es,
              }
            )}h`}</span>
            <a
              className="c-event-details__button"
              href={url}
              target="_blank"
              rel="noopener noreferrer">
              Añadir a Google Calendar
            </a>
          </div>
          {haveGoogleMapsLocation && (
            <div className="c-event-details__location">
              <h3 className="c-event-details__title">
                <LocationOnOutlined />
                Lugar
              </h3>
              <span className="c-event-details__span">
                {location?.formatted_address}
              </span>
              <a
                className="c-event-details__button"
                target="_blank"
                rel="nofollow noreferrer"
                href={`https://www.google.com/maps/search/?api=1&query=${location?.lat},${location?.lng}&query_place_id=${location?.place_id}`}>
                Ver en Google Maps
              </a>
            </div>
          )}
          {user && (
            <div className="c-event-details__promoter">
              <div>
                <h3 className="c-event-details__title">
                  <PersonOutline />
                  Organiza
                </h3>
                <span className="c-event-details__span">{user.name}</span>
                <span className="c-event-details__span">{user.email}</span>
                <span className="c-event-details__span">{user.phone}</span>
                <a
                  className="c-event-details__button"
                  target="_blank"
                  rel="nofollow noreferrer"
                  href={
                    user.web?.includes('http') ? user.web : `http://${user.web}`
                  }>
                  {user.web}
                </a>
              </div>
              <div
                className="c-event-details__promoter-image"
                style={{
                  backgroundImage: `url(${getLogo(user)})`,
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                }}></div>
            </div>
          )}
        </div>
        {haveGoogleMapsLocation && (
          <div className="c-event-details__map">
            <GoogleMapReact
              options={{ styles: mapStyles }}
              yesIWantToUseGoogleMapApiInternals
              bootstrapURLKeys={{
                key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
              }}
              defaultCenter={{ lat: location?.lat, lng: location?.lng }}
              defaultZoom={10}>
              <Marker
                lat={location?.lat}
                lng={location?.lng}
                text={location?.formatted_address}
              />
            </GoogleMapReact>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventDetails;
